import React from 'react';

import useImxImrSeasonDropdown from './UseImxImrSeasonDropdown';

import Dropdown from '@usas/ui-web/components/dropdowns/Dropdown';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const ImxImrSeasonDropdown = ({ label, name, value, error, message, onChange }) => {
  const { imxImrSeasonState } = useImxImrSeasonDropdown();

  return imxImrSeasonState?.message
    ? <span className={global.LoadingMsg}>{imxImrSeasonState.message}</span>
    : (
      <Dropdown
        error={error}
        label={label}
        message={message}
        options={imxImrSeasonState.options}
        name={name}
        value={value}
        onChange={onChange}
        areValuesIntegers={true}
        isLoading={imxImrSeasonState?.isArrayLoading} />
    );
};

export default ImxImrSeasonDropdown;